(function($) {
	function lazyLoadImages() {
		var lazyloadImages;
		if ("IntersectionObserver" in window) {
			//IE11 Quick Fix
			if (window.NodeList && !NodeList.prototype.forEach) {
				NodeList.prototype.forEach = Array.prototype.forEach;
			}

			/* Wait for Dom loaded and then do lazy load background images */
			lazyloadImages = document.querySelectorAll('.lazy:not([loading="eager"])');

						var imageObserver = new IntersectionObserver(function(entries, observer) {
				entries.forEach(function(entry) {
					if (entry.isIntersecting) {
						var image = entry.target;


						// Handle background images with data-bg
						if (image.dataset.bg) {
							image.style.backgroundImage = 'url(' + image.dataset.bg + ')';
							image.classList.remove("lazy");

						}
						// Handle background images already set
						else if (image.style.backgroundImage) {
							// Background image is already set, just remove lazy class
							image.classList.remove("lazy");

						}
						// Handle regular images with data-src
						else if (image.dataset.src) {
							image.src = image.dataset.src;
							image.classList.remove("lazy");

						} else {
							image.classList.remove("lazy");
						}

						imageObserver.unobserve(image);
					}
				});
			}, {
				rootMargin: "50px 0px", // Start loading 50px before image enters viewport
				threshold: 0.01
			});

					lazyloadImages.forEach(function(image) {
			imageObserver.observe(image);
		});

		// Manual trigger function for visible lazy elements
		function manualLazyLoad() {

			var visibleLazyImages = document.querySelectorAll('.lazy:not([loading="eager"]):not([style*="display: none"])');


			visibleLazyImages.forEach(function(image) {
				var rect = image.getBoundingClientRect();
				var isVisible = rect.top < window.innerHeight && rect.bottom > 0;

				if (isVisible) {


					if (image.dataset.bg) {
						image.style.backgroundImage = 'url(' + image.dataset.bg + ')';
						image.classList.remove("lazy");

					} else if (image.dataset.src) {
						image.src = image.dataset.src;
						image.classList.remove("lazy");

					}
				}
			});
		}

		// Expose manual trigger globally
		window.manualLazyLoad = manualLazyLoad;
		} else {
			// Fallback for older browsers
			var lazyloadThrottleTimeout;
			lazyloadImages = document.querySelectorAll('.lazy:not([loading="eager"])');

			function lazyload() {
				if (lazyloadThrottleTimeout) {
					clearTimeout(lazyloadThrottleTimeout);
				}

				lazyloadThrottleTimeout = setTimeout(function() {
					var scrollTop = window.pageYOffset;
					lazyloadImages.forEach(function(img) {
						if (img.offsetTop < window.innerHeight + scrollTop) {
							// Handle background images with data-bg
							if (img.dataset.bg) {
								img.style.backgroundImage = 'url(' + img.dataset.bg + ')';
							}
							// Handle regular images with data-src
							else if (img.dataset.src) {
								img.src = img.dataset.src;
							}
							img.classList.remove("lazy");
						}
					});
					if (lazyloadImages.length == 0) {
						document.removeEventListener("scroll", lazyload);
						window.removeEventListener("resize", lazyload);
						window.removeEventListener("orientationChange", lazyload);
					}
				}, 20);
			}
			document.addEventListener("scroll", lazyload);
			window.addEventListener("resize", lazyload);
			window.addEventListener("orientationChange", lazyload);
		}
	}

	// Make lazyLoadImages available globally for other scripts
	window.lazyLoadImages = lazyLoadImages;

	// Initialize lazy loading when DOM is ready
	$(document).ready(function() {
		lazyLoadImages();
	});

	// Re-initialize after AJAX requests
	$(document).ajaxSuccess(function() {
		lazyLoadImages();
	});

	// Also initialize on window load to catch any late-loaded content
	$(window).on('load', function() {
		lazyLoadImages();
	});
})(jQuery);
